import { RowHeight, VizTypes } from '@mode/reports/sandbox/contract';
import { ChartTypes } from '@mode/shared/contract-common';
import { generateUUID } from '@mode/shared/util-js';
import { ReportLayoutActionType } from '@mode/legacy/util-domain';
import { VizPlacement } from '../lib/report-layout-helpers';

export namespace ReportLayoutActions {
  export const Type = ReportLayoutActionType;

  export class AddViz {
    readonly type = Type.AddViz;

    constructor(
      public readonly token: string,
      public readonly chartType: ChartTypes.V1ChartType | ChartTypes.ChartType,
      public readonly vizType: VizTypes,
      public readonly position?: number,
      public readonly placement?: VizPlacement
    ) {}
  }

  // Just for firing the real create chart flow
  export class CreateChart {
    readonly type = Type.CreateChart;

    constructor(
      public readonly queryToken: string,
      public readonly position: number
    ) {}
  }

  export class CloneChart {
    readonly type = Type.CloneChart;

    constructor(
      public readonly token: string,
      public readonly position: number
    ) {}
  }

  export class CreateText {
    readonly type = Type.CreateText;

    public readonly id: string;

    constructor(public readonly position: number) {
      this.id = generateUUID();
    }
  }

  export class RemoveViz {
    readonly type = Type.RemoveViz;

    constructor(
      public readonly token: string,
      public readonly vizType: VizTypes
    ) {}
  }

  export class SetRowHeight {
    readonly type = Type.SetRowHeight;

    constructor(
      public readonly token: string,
      public readonly vizType: VizTypes,
      public readonly height: RowHeight
    ) {}
  }

  export class SetFullTable {
    readonly type = Type.SetFullTable;

    constructor(public readonly token: string) {}
  }

  export class SetAutoTable {
    readonly type = Type.SetAutoTable;

    constructor(public readonly token: string) {}
  }

  export class ToggleTextMargins {
    readonly type = Type.ToggleTextMargins;

    constructor(public readonly token: string) {}
  }

  export class UpdateText {
    readonly type = Type.UpdateText;

    constructor(
      public readonly token: string,
      public readonly text: string
    ) {}
  }

  export class ResizeGridElement {
    readonly type = Type.ResizeGridElement;

    constructor(
      public readonly id: string,
      public readonly direction: string,
      public readonly columnSize: number
    ) {}
  }

  export class MoveGridElement {
    readonly type = Type.MoveGridElement;

    constructor(
      public readonly id: string,
      public readonly row: number,
      public readonly column: number
    ) {}
  }

  export class ReloadFrame {
    readonly type = Type.ReloadFrame;
    constructor(public readonly layout: string) {}
  }

  export type Actions =
    | AddViz
    | CloneChart
    | CreateChart
    | CreateText
    | RemoveViz
    | SetRowHeight
    | SetFullTable
    | SetAutoTable
    | ToggleTextMargins
    | UpdateText
    | ResizeGridElement
    | MoveGridElement
    | ReloadFrame;
}
